import { render, staticRenderFns } from "./CostPrice.vue?vue&type=template&id=e5a2fb80&scoped=true"
import script from "./CostPrice.vue?vue&type=script&lang=js"
export * from "./CostPrice.vue?vue&type=script&lang=js"
import style0 from "./CostPrice.vue?vue&type=style&index=0&id=e5a2fb80&prod&lang=scss&scoped=true"
import style1 from "./CostPrice.vue?vue&type=style&index=1&id=e5a2fb80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2fb80",
  null
  
)

export default component.exports